{
  "page.title": "Search",
  "filter.title": "Filter",
  "results.list.title": "Search Results",
  "facet": {
    "range_separator": "to",
    "range_to": "{{range}} to",
    "range_from": "{{range}} from",

    "filter_by": "Filter by {{facet}}",
    "filter_placeholder": "Filter {{label}}",
    "selected": "Selected",
    "selected_count": "{{facet}}: {{count}} selected",
    "available_options": "Available options",

    "listing_type": "Listing Type",

    "relief_availability": "Availability for Relief Teaching",

    "tags": "Team & Teacher Attributes",
    "educator_profile": "Educator Profile",
    "curriculum": "Curriculum",
    "subject": "Subject",
    "student_range": "Number of students in the class",
    "specialities": "Specialities",
    "specialities.placeholder": "Select one or more specialities",

    "live_session_hours": "Live Session Hours per Fortnight",
    "student_led_session_hours": "Student-led Session Hours per Fortnight",
    "other_session_hours": "Other Session Hours per Fortnight",
    "requestable": "Requestable Sessions",
    "available_space": "Available Space",

    "learning_style_vark": "VARK",
    "learning_style_visual_range": "Visual",
    "learning_style_auditory_range": "Auditory",
    "learning_style_kinesthetic_range": "Kinesthetic",
    "learning_style_read_write_range": "Read/Write",
    "learning_style_visual": "$t(search:facet.learning_style_visual_range)",
    "learning_style_auditory": "$t(search:facet.learning_style_auditory_range)",
    "learning_style_kinesthetic": "$t(search:facet.learning_style_kinesthetic_range)",
    "learning_style_read_write": "$t(search:facet.learning_style_read_write_range)",

    "speciality_religions": "Religions Taught",
    "religion_notes": "Religion Notes",
    "speciality_genders": "Genders Taught",
    "gender_notes": "Gender Notes",
    "speciality_primary_languages": "Primary Languages",
    "primary_language_notes": "Primary Language Notes",
    "speciality_secondary_languages": "Secondary Languages",
    "secondary_language_notes": "Secondary Language Notes",

    "overall_qualitative_assessment": "Overall Qualitative Assessment",
    "subject_grade_range": "Subject Grade Range",

    "naplan_score_numeracy_range": "Numeracy",
    "naplan_score_reading_range": "Reading",
    "naplan_score_writing_range": "Writing",
    "naplan_score_spelling_range": "Spelling",
    "naplan_score_grammar_range": "Grammar",

    "wisc_v_year": "Year",
    "wisc_v_fsiq_range": "Full Scale IQ Percentile",
    "wisc_v_vci_range": "Verbal Comprehension Index(VCI) Percentile",
    "wisc_v_vsi_range": "Visual Spatial Index(VSI) Percentile",
    "wisc_v_wmi_range": "Working Memory Index(WMI) Percentile",
    "wisc_v_psi_range": "Processing Speed Index(PSI) Percentile",
    "wisc_v_fri_range": "Fluid Reasoning Index(FRI) Percentile",

    "socio_economic_parent_education_range": "Parent Education",
    "socio_economic_parent_occupation_range": "Parent Occupation",

    "learning_style_kolb": "Kolb's Experiential Learning Theory",
    "learning_style_concrete_exp_range": "Concrete Experience (CE)",
    "learning_style_abstract_conc_range": "Abstract Conceptualization (AC)",
    "learning_style_active_exp_range": "Active Experimentation (AE)",
    "learning_style_reflective_obs_range": "Reflective Observation (RO)",
    "learning_style_concrete_exp": "$t(search:facet.learning_style_concrete_exp_range)",
    "learning_style_abstract_conc": "$t(search:facet.learning_style_abstract_conc_range)",
    "learning_style_active_exp": "$t(search:facet.learning_style_active_exp_range)",
    "learning_style_reflective_obs": "$t(search:facet.learning_style_reflective_obs_range)",

    "learning_style_gardner": "Gardner's Multiple Intelligences Theory",
    "learning_style_linguistic_range": "Linguistic",
    "learning_style_logical_range": "Logical-Mathematical",
    "learning_style_spatial_range": "Spatial",
    "learning_style_body_kinesthetic_range": "Bodily-Kinesthetic",
    "learning_style_musical_range": "Musical",
    "learning_style_interpersonal_range": "Interpersonal",
    "learning_style_intrapersonal_range": "Intrapersonal",
    "learning_style_naturalistic_range": "Naturalistic",
    "learning_style_linguistic": "$t(search:facet.learning_style_linguistic_range)",
    "learning_style_logical": "$t(search:facet.learning_style_logical_range)",
    "learning_style_spatial": "$t(search:facet.learning_style_spatial_range)",
    "learning_style_body_kinesthetic": "$t(search:facet.learning_style_body_kinesthetic_range)",
    "learning_style_musical": "$t(search:facet.learning_style_musical_range)",
    "learning_style_interpersonal": "$t(search:facet.learning_style_interpersonal_range)",
    "learning_style_intrapersonal": "$t(search:facet.learning_style_intrapersonal_range)",
    "learning_style_naturalistic": "$t(search:facet.learning_style_naturalistic_range)",

    "learning_preference_description": "Learning Preference Description",
    "learning_preference_individual": "Learning Individually (Independent Learning)",
    "learning_preference_group": "Learning in Groups (Collaborative Learning)",
    "learning_preference_like_students": "Learning with Like Students (Homogeneous Grouping)",
    "learning_preference_diverse_students": "Learning with Diverse Students (Heterogeneous Grouping)",
    "learning_preference_teacher_centered_range": "Teacher-Centered vs. Student-Centered Learning",
    "learning_preference_structured_range": "Structured vs. Flexible Learning",
    "learning_preference_technology_enhanced_range": "Traditional vs Technology-Enhanced Learning",
    "learning_preference_by_doing_range": "Learning by Doing vs. Learning by Observing",

    "eyesight": "Eyesight",
    "adhd": "ADHD",
    "autism": "Autism",
    "depression": "Depression",

    "socio_economic_aboriginal_torres_strait_islander": "Aboriginal or Torres Strait Islander",
    "socio_economic_icsea_percentile_range": "School ICSEA Percentile",
    "socio_economic_other_comment": "General Comment",
    "socio_economic_icsea_comment": "School ICSEA Comment",

    "wiat_iv_age": "Age",
    "wiat_iv_total_achievement_composite_range": "Percentile Total Achievement Composite Percentile",
    "wiat_iv_word_reading_range": "Word Reading Percentile",
    "wiat_iv_reading_comprehension_range": "Reading Comprehension Percentile",
    "wiat_iv_spelling_range": "Spelling Percentile",
    "wiat_iv_sentence_composition_range": "Sentence Composition Percentile",
    "wiat_iv_math_problem_solving_range": "Math Problem Solving Percentile",
    "wiat_iv_numerical_operations_range": "Numerical Operations Percentile",
    "wiat_iv_reading_composite_range": "Reading Composite Percentile",
    "wiat_iv_written_expression_composite_range": "Written Expression Composite Percentile",
    "wiat_iv_mathematics_composite_range": "Mathematics Composite Percentile",
    "wiat_iv_basic_reading_composite_range": "Basic Reading Composite Percentile",
    "wiat_iv_decoding_composite_range": "Decoding Composite Percentile",
    "wiat_iv_reading_fluency_composite_range": "Reading Fluency Composite Percentile",
    "wiat_iv_math_fluency_composite_range": "Math Fluency Composite Percentile",
    "wiat_iv_writing_fluency_composite_range": "Writing Fluency Composite Percentile",
    "wiat_iv_oral_language_composite_range": "Oral Language Composite Percentile",
    "wiat_iv_phonological_proc_composite_range": "Phonological Processing Composite Percentile",
    "wiat_iv_ortho_proc_composite_range": "Orthographic Processing Composite Percentile",
    "wiat_iv_ortho_proc_extended_composite_range": "Orthographic Processing Extended Composite Percentile",
    "wiat_iv_dyslexia_index_composite_range": "Dyslexia Index Composite Percentile",

    "wais_iv_full_scale_iq_range": "Full Scale IQ Percentile",
    "wais_iv_general_ability_range": "General Ability Index Percentile",
    "wais_iv_verbal_comprehension_range": "Verbal Comprehension Index(VCI) Percentile",
    "wais_iv_perceptual_reasoning_range": "Perceptual Reasoning Index(PRI) Percentile",
    "wais_iv_working_memory_range": "Working Memory Index(WMI) Percentile",
    "wais_iv_proc_speed_range": "Processing Speed Index(PSI) Percentile",

    "aeas_score_reading_range": "Reading Comprehension Percentile",
    "aeas_score_spelling_range": "Vocabulary/Spelling Percentile",
    "aeas_score_written_essay_range": "Written Essay Percentile",
    "aeas_score_listening_range": "Listening Percentile",
    "aeas_score_speaking_range": "Speaking Percentile",
    "aeas_score_overall_range": "Overall Percentile",

    "delivery_mode": "Delivery Mode"
  },
  "common": {
    "show_more": "Show {{count}} more",
    "true": "Yes",
    "false": "No"
  },
  "select_attributes": {
    "religion.label": "$t(search:attributes.speciality_religions)",
    "religion.group": "Religion",
    "gender.label": "$t(search:attributes.speciality_genders)",
    "gender.group": "Gender",
    "languages.primary.label": "$t(search:attributes.speciality_primary_languages)",
    "languages.secondary.label": "$t(search:attributes.speciality_secondary_languages)",
    "languages.group": "Languages",
    "intellectual_ability.group": "Intellectual Ability",
    "intellectual_ability.qualitative.label": "$t(search:attributes.overall_qualitative_assessment)",
    "intellectual_ability.subject_grade.label": "$t(search:attributes.subject_grade)",
    "intellectual_ability.naplan.label": "$t(search:attributes.naplan_score)",
    "intellectual_ability.wisc_v.label": "$t(search:attributes.wisc_v)",
    "intellectual_ability.wiat_iv.label": "$t(search:attributes.wiat_iv)",
    "intellectual_ability.wais_iv.label": "$t(search:attributes.wais_iv)",
    "intellectual_ability.aeas.label": "$t(search:attributes.aeas)",
    "parent_socio_economic.group": "Parent Socioeconomic",
    "parent_socio_economic.label": "$t(search:attributes.parent_socio_economic)",
    "learning_styles.group": "Learning Styles",
    "learning_styles.description.label": "Description",
    "learning_styles.vark.label": "$t(search:attributes.learning_style_vark)",
    "learning_styles.gardner.label": "$t(search:attributes.learning_style_gardner)",
    "learning_styles.kolb.label": "$t(search:attributes.learning_style_kolb)",
    "learning_preferences.group": "Learning Preferences",
    "learning_preferences.label": "$t(search:attributes.learning_preference)",
    "other_information.group": "Other Information",
    "other_information.eyesight.label": "$t(search:attributes.eyesight)",
    "other_information.adhd.label": "$t(search:attributes.adhd)",
    "other_information.autism.label": "$t(search:attributes.autism)",
    "other_information.depression.label": "$t(search:attributes.depression)",
    "student_socio_economic.group": "Socio Economic",
    "student_socio_economic.label": "$t(search:attributes.student_socio_economic)"
  },

  "listing_type": {
    "team": "Team",
    "personal": "Individual Teacher"
  },
  "relief_listings": {
    "listing_type": {
      "learner": "School",
      "educator": "Educator"
    },
    "delivery_mode": {
      "in-person": "In Person",
      "online": "Online"
    }
  },
  "relief_availability": {
    "open_to_invitations": "Available"
  },
  "attributes": {
    "speciality_religions": "Religion",
    "speciality_genders": "Gender",
    "speciality_primary_languages": "Primary Language",
    "speciality_secondary_languages": "Secondary Language",
    "overall_qualitative_assessment": "Overall Qualitative Assessment",
    "subject_grade": "Subject Grade Range",
    "naplan_score": "NAPLAN Score (Year 9)",
    "wisc_v": "WISC V",
    "wiat_iv": "WIAT IV",
    "wais_iv": "WAIS IV",
    "aeas": "AEAS",
    "parent_socio_economic": "Parent Socioeconomic Details",
    "learning_style_vark": "VARK",
    "learning_style_gardner": "Gardner's Multiple Intelligences",
    "learning_style_kolb": "Kolb's Experiential Learning Theory",
    "learning_preference": "Student's Learning Preferences",
    "eyesight": "Eyesight",
    "adhd": "ADHD",
    "autism": "Autism",
    "depression": "Depression",
    "student_socio_economic": "Student Socio Economic Details"
  },
  "labels": {
    "a_range": "A+ to A",
    "b_range": "B+ to B",
    "c_range": "C+ to C",
    "d_range": "D+ to D",
    "e_range": "E+ to E",

    "not_at_all": "Not at all",
    "mildly": "Mildly",
    "average": "Average",
    "high_extent": "To a high extent",
    "very_high_extent": "To a very high extent",

    "a_plus": "A+",
    "a": "A",
    "b_plus": "B+",
    "b": "B",
    "c_plus": "C+",
    "c": "C",
    "d_plus": "D+",
    "d": "D",
    "e_plus": "E+",
    "e": "E",

    "needs_additional_support": "Needs additional support",
    "developing": "Developing",
    "strong": "Strong",
    "exceeding": "Exceeding",

    "not_stated": "Not Stated",
    "bachelor_degree_or_above": "Bachelor Degree or Above",
    "advanced_diploma_or_diploma": "Advanced Diploma or Diploma",
    "certificate1to4": "Certificate 1 to 4",
    "year_12_or_equivalent": "Year 12 or Equivalent",
    "year_11_or_equivalent": "Year 11 or Equivalent",
    "year_10_or_equivalent": "Year 10 or Equivalent",
    "year_9_or_equivalent_or_below": "Year 9 or Equivalent",

    "senior_managers_and_professionals": "Senior management in large business organisation, government administration and defence, and qualified professionals",
    "other_managers_and_associate_professionals": "Other business managers, arts/media/sports persons and associate professionals",
    "tradespeople_and_skilled_office_sales_and_service_staff": "Tradespeople, skilled office, sales and service staff",
    "unskilled_labourers_office_sales_and_service_staff": "Machine operators, hospitality staff, assistants, labourers and related workers",
    "unemployed": "Unemployed and pensioners",

    "0_mild_or_no_visual_impairment": "Category 0: Mild or no visual impairment",
    "1_moderate_visual_impairment": "Category 1: Moderate visual impairment",
    "2_severe_visual_impairment": "Category 2: Severe visual impairment",
    "3_blindness": "Category 3: Blindness",
    "4_blindness": "Category 4: Blindness",
    "5_blindness": "Category 5: Blindness",

    "f90_0_predominantly_inattentive_type": "F90.0 Attention-deficit hyperactivity disorder, predominantly inattentive type",
    "f90_1_predominantly_hyperactive_type": "F90.1 Attention-deficit hyperactivity disorder, predominantly hyperactive type",
    "f90_2_combined_type": "F90.2 Attention-deficit hyperactivity disorder, combined type",
    "f90_8_other_type": "F90.8 Attention-deficit hyperactivity disorder, other type",
    "f90_9_unspecified_type": "F90.9 Attention-deficit hyperactivity disorder, unspecified type",

    "f84_0_childhood_autism": "F84.0 Childhood autism",
    "f84_1_atypical_autism": "F84.1 Atypical autism",
    "f84_2_rett_syndrome": "F84.2 Rett syndrome",
    "f84_3_other_childhood_disintegrative_disorder": "F84.3 Other childhood disintegrative disorder",
    "f84_4_overactive_disorder_associated_with_mental_retardation_and_stereotyped_movements": "F84.4 Overactive disorder associated with mental retardation and stereotyped movements",
    "f84_5_asperger_syndrome": "F84.5 Asperger syndrome",
    "f84_8_other_pervasive_developmental_disorders": "F84.8 Other pervasive developmental disorders",
    "f84_9_unspecified_pervasive_developmental_disorder": "F84.9 Unspecified pervasive developmental disorder",

    "f33_0_recurrent_depressive_disorder_current_episode_mild": "F33.0 Recurrent depressive disorder, current episode mild",
    "f33_1_recurrent_depressive_disorder_current_episode_moderate": "F33.1 Recurrent depressive disorder, current episode moderate",
    "f33_2_recurrent_depressive_disorder_current_episode_severe_without_psychotic_symptoms": "F33.2 Recurrent depressive disorder, current episode severe without psychotic symptoms",
    "f33_3_recurrent_depressive_disorder_current_episode_severe_with_psychotic_symptoms": "F33.3 Recurrent depressive disorder, current episode severe with psychotic symptoms",
    "f33_4_recurrent_depressive_disorder_currently_in_remission": "F33.4 Recurrent depressive disorder, currently in remission",
    "f33_8_other_recurrent_depressive_disorders": "F33.8 Other recurrent depressive disorders",
    "f33_9_recurrent_depressive_disorder_unspecified": "F33.9 Recurrent depressive disorder, unspecified",

    "learning_preference.teacher_centered.most_teacher_centered": "Most Teacher Centered Learning",
    "learning_preference.teacher_centered.more_teacher_centered": "More Teacher Centered Learning",
    "learning_preference.teacher_centered.equal_teacher_student": "Equal Teacher and Student Centered Learning",
    "learning_preference.teacher_centered.more_student_centered": "More Student Centered Learning",
    "learning_preference.teacher_centered.most_student_centered": "Most Student Centered Learning",

    "learning_preference.structured.most_structured": "Most Structured Learning",
    "learning_preference.structured.more_structured": "More Structured Learning",
    "learning_preference.structured.equal_structured_flexible": "Equal Structured and Flexible Learning",
    "learning_preference.structured.more_flexible": "More Flexible Learning",
    "learning_preference.structured.most_flexible": "Most Flexible Learning",

    "learning_preference.technology_enhanced.most_traditional": "Most Traditional Learning",
    "learning_preference.technology_enhanced.more_traditional": "More Traditional Learning",
    "learning_preference.technology_enhanced.equal_traditional_tech": "Equal Traditional and Technology Enhanced Learning",
    "learning_preference.technology_enhanced.more_tech_enhanced": "More Technology Enhanced Learning",
    "learning_preference.technology_enhanced.most_tech_enhanced": "Most Technology Enhanced Learning",

    "learning_preference.by_doing.most_by_doing": "Most Learning by Doing",
    "learning_preference.by_doing.more_by_doing": "More Learning by Doing",
    "learning_preference.by_doing.equal_doing_observing": "Equal Learning by doing and observing",
    "learning_preference.by_doing.more_by_observing": "More Learning by Observing",
    "learning_preference.by_doing.most_by_observing": "Most Learning by Observing",

    "learning_preference.teacher_centered.label": "Teacher-Centered vs. Student-Centered Learning",
    "learning_preference.structured.label": "Structured vs. Flexible Learning",
    "learning_preference.technology_enhanced.label": "Traditional vs Technology-Enhanced Learning",
    "learning_preference.by_doing.label": "Learning by Doing vs. Learning by Observing",

    "hours": "hours",
    "hours_1_2": "1 - 2 $t(search:labels.hours)",
    "hours_3_4": "3 - 4 $t(search:labels.hours)",
    "hours_5_6": "5 - 6 $t(search:labels.hours)",
    "hours_7_8": "7 - 8 $t(search:labels.hours)",
    "hours_9_10": "9 - 10 $t(search:labels.hours)",
    "hours_11_12": "11 - 12 $t(search:labels.hours)",
    "hours_13_plus": "13+ $t(search:labels.hours)",

    "both": "Both",
    "yes": "Yes",
    "no": "No",

    "available_space.0_to_5": "0 - 5 students",
    "available_space.6_to_10": "6 - 10 students",
    "available_space.11_to_15": "11 - 15 students",
    "available_space.16_to_20": "16 - 20 students",
    "available_space.20_plus": "20+ students"
  },
  "result": {
    "educators": {
      "empty.label": "No educators found",
      "empty.description": "We couldn't find any educators that match your search criteria. Try adjusting your search criteria or starting a new team."
    },
    "relief_listings": {
      "empty.label": "No relief listings found",
      "empty.description": "We couldn't find any relief listings that match your search criteria. Try adjusting your search criteria"
    },
    "specialities": "Specialities:",
    "tags": "Tags:",
    "educator_profile": "Educator Profile:",
    "more": "+{{count}} more",
    "curriculum": "Curriculum:",
    "subject": "Subject:",
    "class_size.label": "Class Size",
    "class_size": "{{min}} - {{max}} students",
    "timezone_id.label": "Timezone",
    "educator.label": "Educator",
    "paging.info": "Showing {{start}} - {{end}} out of {{total}}",
    "empty.label": "No classes found",
    "empty.description": "We couldn't find any classes that match your search criteria. Try adjusting your search criteria or starting a new class.",
    "empty.start_action": "Start a class",
    "empty.request_action": "Request a class",
    "speciality": "Speciality:",
    "active_filters": "Active Filters:",
    "clear_filters": "Clear",
    "view": "View Class"
  },

  "filters": {
    "name": "Name",
    "class_name.placeholder": "Search for a class by name"
  },

  "tabs": {
    "educators": "Educators",
    "classes": "Classes",
    "relief_listings": "Relief Listings"
  },

  "show": {
    "shortlist": "Shortlist",
    "class": {
      "title": "Class Details"
    },
    "teacher": {
      "title": "Teacher Profile",
      "invite": "Invite",
      "invite_to_relief_listing": "Invite to Relief Listing",
      "primary_language": "Primary Language:",
      "secondary_language": "Secondary Language:",
      "gender": "Gender:",
      "country": "Country:",
      "religion": "Religion:",
      "race": "Race:",
      "citizenships": "Citizenship(s):",
      "origin_country": "Country of Origin:",
      "mobile": "Mobile:",
      "background_video": {
        "title": "Background Video",
        "empty": "No video available"
      },
      "accreditations": {
        "title": "Accreditations",
        "subsections": {
          "state_approvals": "State Approvals",
          "other_accreditations": "Other Accreditations"
        }
      },
      "experience": {
        "title": "Experience",
        "subsections": {
          "teaching_experience": "Teaching Experience",
          "education_qualifications": "Education Qualifications",
          "work_experience": "Work Experience",
          "assessor_experience": "Assessor Experience",
          "examiner_experience": "Examiner Experience",
          "students_taught": "Students Taught"
        },
        "resume": "Download Resume",
        "students_taught": {
          "subsections": {
            "genders": "Genders",
            "religions": "Religions",
            "primary_languages": "Primary Languages",
            "secondary_languages": "Secondary Languages",
            "depressions": "Depressions",
            "adhds": "ADHDs",
            "intellectual_ability": "Intellectual Ability",
            "socioeconomic": "Socioeconomic",
            "other": "Other"
          }
        }
      },
      "teaching_methods": {
        "title": "Teaching Methods",
        "subsections": {
          "teaching_technology": "Teaching Technology Used"
        }
      },
      "personal_style": {
        "title": "Personal Style",
        "subsections": {
          "style_autocratic": "Autocratic",
          "style_reserved": "Reserved",
          "style_talk": "Chalk/Talk",
          "style_consultative": "Consultative",
          "style_participative": "Participative",
          "style_comment": "Comment"
        }
      }
    },
    "team": {
      "title": "Team Profile",
      "website": "Website",
      "video": "Video",
      "teachers": "Teachers",
      "teacher_profile": "View Profile",
      "classes": "Classes",
      "class_details": "View Details",
      "apply": "Apply"
    },
    "missing_attribute": "N/A",
    "educator.relief_listing": {
      "title": "School Relief Listing",
      "apply": "Apply",
      "duration": "{{start}} to {{end}}",
      "description": "Description",
      "timetable": "Timetable",
      "start_date": "Start Date",
      "end_date": "End Date",
      "times": "{{start}} - {{end}}",
      "tags": "Tags",
      "times_timezone": "$t(show.learner.relief_listing.times) ({{timezone}})"
    },
    "learner.relief_listing": {
      "title": "School Relief Listing",
      "apply": "Apply",
      "duration": "{{start}} to {{end}}",
      "description": "Description",
      "school_details": "School",
      "school_name": "School Name",
      "delivery_mode": "Delivery Modes",
      "timetable": "Timetable",
      "start_date": "Start Date",
      "end_date": "End Date",
      "times": "{{start}} - {{end}}",
      "tags": "Tags",
      "times_timezone": "$t(show.learner.relief_listing.times) ({{timezone}})"
    }
  },
  "records": {
    "class": "Class",
    "teacher": "Teacher",
    "team": "Team",
    "relief_listing": "Relief Listing"
  }
}
